import axios from 'axios';

const Pustakapi = axios.create({
  //baseURL: 'http://localhost:8888/qbank/public/api', // backend base URL http://pustakques.webndro.com
  baseURL: 'https://odiabook.com',
  headers: {
    'Content-Type': 'application/json'
  }
});

export default Pustakapi;